export const columns = [
    {
      label: 'ID',
      field: 'checkbox',
      widthPercent: 3
    },
    {
      label: 'ID do Pedido',
      field: 'order_id',
      widthPercent: 10
    },
    {
      label: 'ID do Sub Pedido',
      field: 'sub_order_id',
      widthPercent: 10
    },
    {
      label: 'Ano',
      field: 'serie_id',
      widthPercent: 10
    },
    {
      label: 'Data da Compra',
      field: 'created',
      widthPercent: 10
    },
    {
      label: 'CPF/CNPJ do Comprador',
      field: 'buyer_cpf',
      widthPercent: 17
    },
    {
      label: 'Nome do Comprador',
      field: 'buyer_name',
      widthPercent: 15
    },
    {
      label: 'Nome do Aluno',
      field: 'student_name',
      widthPercent: 15
    },
    ,
    {
      label: 'Pagamento',
      field: 'status',
      widthPercent: 10,
      formatter: (text) => text.replace(/pagamento /ig, '')
    },
  ];